import BasePerimeter from './base';

export default new BasePerimeter({
    purpose: 'agencies',
    govern: {
        'can view': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isAgencyAdmin())
        },
        'can edit': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isAgencyAdmin() || this.isClientAdmin());
        },
        'can updateCreditCard': function () {
            return (this.isAgencyAdmin() || this.isClientAdmin());
        },
        'can filterClient': function () {
            return (this.isSuperAdmin() || this.isAdmin())
        },
        'can updateAutomateReport': function () {
            return (this.isSuperAdmin() || this.isAdmin() || this.isAgencyAdmin() || this.isClientAdmin());
        },
        'can archive': function () {
            return (this.isSuperAdmin() || this.isAdmin());
        },
    }
});
